import { Component, EventEmitter, input, Input, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { OverlayComponent } from '../../../overlay/overlay.component'
import { defaultModalInputValues } from '@components/group-modals/data/default-modal-input-values'
import { InlineTranslationDirective } from '@directives/inline-translation/inline-translation.directive'
import { CdkScrollableModule } from '@angular/cdk/scrolling'

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule, InlineTranslationDirective, OverlayComponent, CdkScrollableModule],
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent {

  // signal inputs need ng17
  @Input({ required: true }) modalTitle: string
  disableButtons = input<boolean>(false)
  @Input() modalTitleCode: string
  @Input() modalIcon: string
  @Input() height: string
  @Input() width: string = defaultModalInputValues.width

  @Output() modalClose = new EventEmitter<void>()

  readonly modalHeaderHeight = '54px'
  readonly modalFooterHeight = '52px'

  onModalClose() {
    this.modalClose.emit()
  }
}
